import React from 'react';
import { motion } from 'framer-motion';
import Icon from '../../../components/AppIcon';

const complianceItems = [
  {
    icon: 'Shield',
    title: 'VG Vergund — Vlaanderen & Brussel',
    body: 'Officiële Vlaamse overheidsvergunning voor uitzendarbeid. Vereist voor alle uitzendbureaus in België. Jaarlijks vernieuwd, openbaar verifieerbaar via VDAB-databank.',
    badge: '● ACTIEF • VERLENGD 2025',
    badgeColor: '#00E5A0',
  },
  {
    icon: 'Users',
    title: 'Sociale Zekerheidsinschrijving',
    body: 'Alle geplaatste werknemers worden vanaf dag één ingeschreven bij de Belgische RSZ. Werkgeversbijdragen, ziekteverzekering en pensioenrechten volledig gedekt.',
    badge: '● VERPLICHT • VOLLEDIG BEHEERD',
    badgeColor: '#00E5A0',
  },
  {
    icon: 'FileCheck',
    title: 'Onmiddellijke Arbeidsaangifte (Dimona)',
    body: 'Elektronische Dimona-aangifte ingediend vóór het eerste werkuur op elke opdracht. Nultolerantie voor zwartwerk. Opdrachtgevers ontvangen aangifte op dag één.',
    badge: '● VÓÓR AANKOMST • ZELFDE DAG',
    badgeColor: '#00E5A0',
  },
  {
    icon: 'Globe',
    title: 'A1 Draagbare Documenten',
    body: 'A1-certificaten uitgereikt aan alle grensoverschrijdende werknemers ter bevestiging van hun sociale zekerheidsjurisdictie. Voorkomt dubbele bijdragen en bevestigt de rechtsstatus in België.',
    badge: '● GRENSOVERSCHRIJDEND • EU COMPLIANT',
    badgeColor: '#00E5A0',
  },
  {
    icon: 'Scale',
    title: 'Detacheringsrichtlijn',
    body: 'Volledige compliance met Belgische minimumloonvereisten, arbeidsomstandigheden en gelijke behandeling voor alle EU-onderdanen conform de Detacheringsrichtlijn.',
    badge: '● EU RICHTLIJN • VOLLEDIG NAGELEEFD',
    badgeColor: '#00E5A0',
  },
  {
    icon: 'Lock',
    title: 'Gegevensbescherming (GDPR)',
    body: 'Kandidaat- en opdrachtgeversgegevens verwerkt conform de GDPR. Verwerkingsovereenkomsten beschikbaar voor alle klanten. DPO geregistreerd bij de Belgische GBA (APD/GBA).',
    badge: '● GDPR COMPLIANT • DPO GEREGISTREERD',
    badgeColor: '#00E5A0',
  },
];

const VolledigCompliant = () => {
  return (
    <section id="compliant" className="py-20 md:py-28 bg-[#0A0A0A] relative overflow-hidden">
      <div className="absolute top-0 left-0 w-96 h-96 rounded-full blur-[140px] opacity-5" style={{ background: '#00E5A0' }} />
      <div className="max-w-6xl mx-auto px-6 lg:px-8 relative z-10">
        <div className="mb-14">
          <motion.h2
            className="text-5xl md:text-6xl lg:text-7xl font-heading font-bold leading-none mb-6"
            style={{ color: '#FFFFFF' }}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            VOLLEDIG<br /><span style={{ color: '#00E5A0' }}>COMPLIANT</span>
          </motion.h2>
          <motion.p
            className="text-base max-w-2xl leading-relaxed"
            style={{ color: '#888888' }}
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ delay: 0.15 }}
          >
            BVM Group opereert binnen het volledige Belgische en EU-rechtskader voor grensoverschrijdende personeelsinzet. Elke certificering wordt bijgehouden, geauditeerd en is verifieerbaar.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px" style={{ background: '#1A1A1A' }}>
          {complianceItems?.map((item, i) => (
            <motion.div
              key={i}
              className="p-8 group"
              style={{ background: '#0A0A0A' }}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.08 }}
              whileHover={{ background: '#0F0F0F' }}
            >
              <div className="w-10 h-10 rounded flex items-center justify-center mb-5" style={{ border: '1px solid #2A2A2A' }}>
                <Icon name={item?.icon} size={20} color="#00E5A0" />
              </div>
              <h3 className="text-base font-heading font-semibold text-white mb-3">{item?.title}</h3>
              <p className="text-sm leading-relaxed mb-5" style={{ color: '#777777' }}>{item?.body}</p>
              <span className="text-xs font-body font-semibold" style={{ color: item?.badgeColor }}>{item?.badge}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VolledigCompliant;
